<template>
  <div class="boxs">
    <div style="display: flex;justify-content: flex-end;">
      <div class="item" @click="showUp" style="margin:0px 10px;">模块编辑</div>
      <div class="item" @click="showMainUp">内容编辑</div>
    </div>
    <template>
      <el-dialog class="editUp" center :visible.sync="dialogVisible" @close="onColose" width="35%">
        <div slot="title" class="title">
          <span>{{ editData.name }}编辑</span><span></span>
        </div>
        <!-- <div class="label">
              <span>指示器：</span> <el-radio v-model="radio" label="1">显示</el-radio>
              <el-radio v-model="radio" label="2">不显示</el-radio>
            </div> -->
        <div class="contents" v-if="editData">
          <div>
            <span class="label"><i class="el-icon-collection-tag"></i>模块名称</span>
            <el-input class="labelName" v-model="editData.name" placeholder="请输入模块名称"></el-input>
          </div>
          <div>
            <span class="label"><i class="el-icon-document"></i>模块内容</span>
            <el-tree class="tree" :data="editData.childrenList" :props="defaultProps" node-key="id" default-expand-all
              :expand-on-click-node="false">
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <div class="row">
                  <div class="name">{{ node.label }}</div>
                  <div class="operate">
                    <el-button v-if="node.level < 3" type="text" size="mini" @click="add(data, node)">
                      <i class="el-icon-circle-plus-outline icons"></i>
                    </el-button>
                    <el-button type="text" size="mini" v-if="!data.name.includes('数字孪生+') && !data.name.includes('Mapmost 宣传册')" @click=" edit(data, node)">
                      <i class="el-icon-edit icons"></i>
                    </el-button>
                    <!-- <el-button v-if="node.level != 1" type="text" size="mini" @click="editLink(data, node)">
                      <i class="el-icon-link icons"></i>
                    </el-button> -->
                    <el-button type="text" size="mini" @click="sort(data, node)" v-if="!data.name.includes('Mapmost 宣传册')">
                      <i class="el-icon-sort icons"></i>
                    </el-button>
                    <el-button type="text" size="mini" v-if="!data.name.includes('Mapmost 宣传册')">
                      <el-popconfirm title="确定删除该条信息吗？" @confirm="del(data)">
                        <i slot="reference" style="color: #ff0000;" class="el-icon-delete icons"></i>
                      </el-popconfirm>

                    </el-button>

                  </div>
                </div>
              </div>
            </el-tree>

            <div class="addType" style="padding: 10px 0;" @click="addData">
              <i class="el-icon-plus avatar-uploader-icon">添加标签分类</i>
            </div>
          </div>

        </div>

      </el-dialog>
      <!-- main -->
      <el-dialog class="editUp" center :visible.sync="dialogMainVisible" @close="onColose" width="35%">
        <div slot="title" class="title">
          <span>{{ editData.name }}内容编辑</span><span></span>
        </div>
        <div class="contents" v-if="editData">
          <!-- <div>
            <span class="label"><i class="el-icon-collection-tag"></i>模块名称</span>
            <el-input class="labelName" v-model="editData.name" placeholder="请输入模块名称"></el-input>
          </div> -->
          <div>
            <span class="label"><i class="el-icon-document"></i>模块内容</span>
            <el-tree class="tree" ref="tree" :data="editData.childrenList" :props="defaultProps" node-key="id"
              default-expand-all :expand-on-click-node="false">
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <div class="row">
                  <div class="name">{{ node.label }}</div>
                  <div class="operate">
                    <!-- node.level != 1 -->
                    <el-button v-if="node.isLeaf" type="text" size="mini" @click="editLink(data, node)">
                      <!-- <i class="el-icon-link icons"></i> -->
                      <i class="el-icon-edit icons"></i>
                    </el-button>
                  </div>
                </div>
              </div>
            </el-tree>
            <!-- <div class="addType" style="padding: 10px 0;" @click="addData">
              <i class="el-icon-plus avatar-uploader-icon">添加标签分类</i>
            </div> -->
          </div>

        </div>

      </el-dialog>
    </template>
    <el-dialog title="链接设置" :visible.sync="linkVisible" :width="dialogWidth" :before-close="handleClose">

      <el-form :model="linkData" :rules="rules" ref="linkData" label-width="100px" class="demo-linkData">
        <el-form-item label="链接方式" prop="resource">
          <el-radio-group v-model="linkData.resource">
            <el-radio label="文件链接"></el-radio>
            <el-radio label="超链接"></el-radio>
            <el-radio label="自定义编辑"></el-radio>
            <el-radio label="自定义方案"></el-radio>

          </el-radio-group>
        </el-form-item>
        <!-- <div v-if="linkData.resource === '自定义编辑'" style="margin-left: 100px;color:red;">注：请上传16:9的图片（只能上传图片）</div> -->
        <el-form-item v-if="linkData.resource === '文件链接'">
          <UploadPdf @onSuccess="UpSuccess">
            <div class="upBtn">
              <el-button size="small" type="primary">文件上传</el-button>
              <div v-if="linkData.linkUrl" class="text">文件地址：{{ linkData.linkUrl }}</div>
            </div>

          </UploadPdf>
        </el-form-item>
        <el-form-item v-if="linkData.resource === '自定义编辑'">
          <HtmlText ref="editHtml" />
        </el-form-item>
        <el-form-item v-if="linkData.resource === '超链接'" label="超链接" prop="desc">
          <el-input type="text" v-model="url" maxlength="200"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkVisible = false">取 消</el-button>
        <el-button type="primary" @click="onQuery">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="formTitle" :visible.sync="dialogVisible1" width="20%" :close-on-click-modal="false">
      <el-form ref="form" :model="editForm" label-width="80px">
        <el-input v-model="editInput"></el-input>
          <img class="img" :src="editImg" alt="" style="width: 150px;height: 200px;margin-top: 40px;">
        <UploadImg @onSuccess="onSuccess" style="margin-top: 10px;">
          <div style="padding: 10px 0;">
            <i class="el-icon-plus avatar-uploader-icon">添加图片</i>
          </div>
        </UploadImg>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="sureForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import { delType, addCommonData } from "@/api/news.js"
import { getProductProgrammeList, addProductProgramme, delProgramme } from "@/api/solutio";
import UploadPdf from "./uploadPdf.vue"
import HtmlText from "./editHtml.vue"
import UploadImg from "./uploadImg.vue"
export default {
  components: {
    UploadPdf, HtmlText, UploadImg,
  },
  props: ['list', 'index', 'orname',],
  data() {
    return {
      editForm: {},
      formTitle: '',
      editInput: '',
      editImg: '',
      editparentId: '',
      editId: '',
      dialogVisible1: false,
      dialogVisible: false,
      linkVisible: false,
      scname: '',//父级菜单名字
      radio: '1',
      editData: {},
      url: '',
      linkData: {
        url: ''
      },
      title: "",
      defaultProps: {
        label: 'name',
        children: 'childrenList'
      },
      rules: {},
      dialogMainVisible: false,
      dialogWidth: '30%',
    }
  },
  mounted() {
    console.log(this.list)

    // this.$message.success('链接设置成功');
    // this.linkData = JSON.parse(JSON.stringify(this.list));

  },
  watch: {
    'linkData.resource': function (newValue, oldValue) {

      if (newValue === '自定义方案') {
        // this.jumpTo(this.linkData)


      } else if (newValue === '自定义编辑') {
        this.dialogWidth = '40%'; // 设置el-dialog的大小为大
        //回显自定义编辑的内容
        this.$nextTick(() => {
          let imgUrl = this.url
          imgUrl = imgUrl.split(',')
          let imgLabel = ''
          for (let i = 0; i < imgUrl.length; i++) {
            imgLabel += `<img src="${imgUrl[i]}" alt="" data-href="${imgUrl[i]}" style=""/>`
          }
          imgLabel = '<p>' + imgLabel + '</p>'
          this.$refs.editHtml.html = imgLabel
        })
      } else {
        this.dialogWidth = '30%'; // 设置el-dialog的大小为小
      }
    }
  },
  methods: {
    onSuccess(e) {
      this.editImg = e
      
    },
    TextTourlType(type) {
      let text = ''
      switch (type) {
        case 1:
          text = '自定义编辑'
          break;
        case 2:
          text = '超链接'
          break;
        case 3:
          text = '文件链接'
          break;
        case 4:
          text = '自定义方案'
          break;
      }
      return text
    },
    //跳转页面
    jumpTo(data) {
      this.$router.push({
        path: '/pageTemplate',
        query: {
          data: JSON.stringify(data),
          orname: this.orname,
          scname: this.scname
        }
      })
    },
    handleClose() {
      this.linkVisible = false
    },
    onColose() {
      this.$emit('onClose')
    },
    handleChange(data, node) {
      addProductProgramme(data).then(res => {

        this.getData();
      })
    },
    getData() {
      getProductProgrammeList({ isRelease: this.$store.state.editStatus }).then(res => {
        this.editData = res.data[this.index]
      })
    },
    UpSuccess(data) {
      this.linkData.linkUrl = data.fileUrl;

      this.$set(this.linkData, 'linkName', data.fileName)
    },
    addData() {
      this.$prompt('请输入标签类型名称', {
        confirmButtonText: '添加',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '内容不能为空',
      }).then(({ value }) => {
        addProductProgramme({
          "childrenUrl": "",
          "createTime": "",
          "isHide": 0,
          "isRelease": 0,
          "name": value,
          "parentId": this.editData.id,
          "releaseTime": "",
          "reqUrl": "",
          "sort": 0,
          "updateTime": "",
        }).then(res => {
          this.$message.success('添加成功');
          this.getData()
        })

      })

    },
    inputValidator(e) {
    },
    onQuery() {
      if (this.linkData.resource != '自定义方案') {

        if (!(this.linkData.linkUrl || this.url)) {
          this.$message.error('请设置链接')
          return
        }
      }
      //判断是否有自定义编辑
      if (this.linkData.resource === '自定义编辑') {
        params.urlType = 3
        this.linkData.reqUrl = this.$refs.editHtml.html;
        console.log(this.$refs.editHtml.html, 'link')
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.linkData.reqUrl, 'text/html');   //转为标签
        const imgElements = doc.getElementsByTagName('img');        //获取标签里面的img
        const srcArray = Array.from(imgElements).map(img => img.getAttribute('src'));   //查找属性
        this.linkData.reqUrl = srcArray
        console.log(srcArray, 'doc');
      }
      let params = this.linkData;

      if (this.linkData.resource === '文件链接') {
        params.reqUrl = this.linkData.linkUrl
        params.urlType = 3
      } else if (this.linkData.resource === '自定义编辑') {
        params.urlType = 1

        params.reqUrl = this.linkData.reqUrl
        if (params.reqUrl.length > 4) {
          return this.$message.error('最多只能上传4张图片')
        }
        params.reqUrl = params.reqUrl.join(',')
      } else if (this.linkData.resource === '自定义方案') {
        params.urlType = 4
        this.jumpTo(this.linkData)
      } else {
        params.urlType = 2
        params.reqUrl = this.url;
      }
      addProductProgramme(params).then(res => {
        this.$message.success('链接设置成功');
        this.linkVisible = false;
        this.getData();
      })
    },
    editLink(v, node) {
      this.scname = this.$refs.tree.getNode(node).parent.data.name
      this.linkData = v;
      this.$set(this.linkData, 'resource', this.TextTourlType(this.linkData.urlType))

      // this.linkData.resource = ;
      if (v.reqUrl && v.reqUrl.indexOf('.pdf') > -1) {
        this.linkData.linkUrl = v.reqUrl
      } else {
        //如果是四张图片
        this.url = v.reqUrl
      }

      this.linkVisible = true
    },
    showUp() {
      this.dialogVisible = true;
      this.getData()

    },
    showMainUp() {
      this.dialogMainVisible = true;
      this.getData()

    },
    del(e) {
      delProgramme({ id: e.id }).then(res => {
        this.$message.success('删除成功');
        this.getData();
      })

    },
    sort(data, node) {
      this.$prompt('数值越小排序越靠前', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.sort || 1,
        inputPattern: /^[0-9]*[1-9][0-9]*$/,
        inputErrorMessage: '只能输入纯数字'
      }).then(({ value }) => {
        data.sort = value;
        addProductProgramme(data).then(res => {
          this.$message.success('排序设置成功');
          this.getData();
        })
      })
    },
    closeForm() {
      this.dialogVisible1 = false
    },
    sureForm() {
      let that = this
      addProductProgramme({
        "name": that.editInput,
        "parentId": that.editparentId,
        "id": that.editId,
        "logo":that.editImg
      }).then(res => {
        this.$message.success('编辑成功');
        this.dialogVisible1 = false
        this.getData();
      })
    },
    edit(v, node) {
      console.log(v, 'vv')
      let that = this
      that.dialogVisible1 = true
      that.formTitle = node.level === 1 ? '标签类型名称编辑' : '标签编辑名称'
      that.editInput = v.name
      that.editparentId = v.parentId
      that.editId = v.id
      that.editImg = v.logo
      // this.$prompt(node.level === 1 ? '标签类型名称编辑' : '标签编辑名称', {
      //   confirmButtonText: '保存',
      //   cancelButtonText: '取消',
      //   inputValue: v.label,
      //   inputValue: v.name || '',
      // }).then(({ value }) => {
      //   addProductProgramme({
      //     "name": value,
      //     "parentId": v.parentId,
      //     "id": v.id

      //   }).then(res => {
      //     this.$message.success('编辑成功');
      //     this.getData();
      //   })
      // })
    },
    add(v, node) {
      let that = this;
      that.$prompt('请输入标签名称', {
        confirmButtonText: '添加',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        addProductProgramme({
          "name": value,
          "parentId": v.id

        }).then(res => {
          this.$message.success('新增成功');
          this.getData()
        })
      })
    },
    onSave() {
      if (this.editData.name == '') {
        this.$message.error('请输入模块名称')
        return
      }
      let params = this.editData;
      params.forEach(e => {
        e.isRelease = 0;
        e.typeName = "资讯";
        e.typeValue = "information";
      })

      addCommonData(params).then(res => {

      })
      this.dialogVisible = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }
}
</script>
    
<style lang="scss" scoped>
.boxs {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: left;

  &:hover {
    border: 1px dashed #ccc;
  }

  div {
    .item {
      padding: 5px 10px;
      background: #007ffe;
      font-style: normal;
      align-items: center;
      display: none;

      cursor: pointer;
      color: #fff;

      &:first-child {
        border-bottom-right-radius: 4px;
      }
    }
  }

  &:hover {
    .item {
      display: inline-flex;
      font-size: 14px;
    }
  }
}

::v-deep .editUp {
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    span {
      &:nth-child(2) {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .contents {
    margin-top: 20px;
    max-height: 500px;
    overflow: hidden;
    overflow-y: auto;

    .img {
      width: 100px;
      height: 50px;
    }

    .label {
      font-size: 15px;
      color: #333;

      i {
        color: #007ffe;
        margin-right: 4px;
      }
    }

    .labelName {
      font-size: 14px;
      margin: 20px 0;
      height: 40px;

      .el-input__inner {
        height: 40px;
      }
    }

    .tree {
      max-height: 300px;
      margin-top: 20px;
      overflow: hidden;
      overflow-y: auto;

      .custom-tree-node {
        width: 100%;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;

          .operate {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .labelName {
            color: #007ffe;
          }

          .icons {
            font-size: 18px;
          }
        }
      }
    }
  }

  .dialog-foote {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}

.addType {
  text-align: center;
  border: 1px dashed #ddd;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  cursor: pointer;
  margin-top: 10px;

  span {
    margin-left: 5px;
  }
}

.upBtn {
  text-align: left;
}

::v-deep .el-tree-node__content {
  height: auto;
}
</style>